import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmr } from '../entity/Stkmr-angular';

export const StkMr006List = [{ id: "1", name: "買" }, { id: "-1", name: "賣" }]; // 買賣別

@Injectable({
  providedIn: 'root'
})
export class StkmrServicePkg extends JkEntityV2 {
  StkMr006List = StkMr006List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkmr();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MR001: '商品代號', MR002: '帳號', MR003: '登入代號', MR004: 'datetime', MR005: '市場別', MR006: '買賣別', MR007: '未平倉部位', MR008: '當沖未平倉部位', MR009: '平均成本', MR010: '單口手續費', MR011: '交易稅', MR012: '一點價值'
    };

    this.fieldNames = 'MR001,MR002,MR003,MR004,MR005,MR006,MR007,MR008,MR009,MR010,MR011,MR012';
    this.fieldLengths = { MR001: 8, MR002: 20, MR003: 10, MR004: 0, MR005: 2, MR006: 3, MR007: 8, MR008: 8, MR009: 11.3, MR010: 8.3, MR011: 11.2, MR012: 8 };
    this.columnDefs = [
      { field: "MR007", headerName: "未平倉部位", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR012", headerName: "一點價值", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR011", headerName: "交易稅", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR010", headerName: "單口手續費", headerTooltip: "", width: 136, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR009", headerName: "平均成本", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR008", headerName: "當沖未平倉部位", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR001", headerName: "商品代號", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MR006", headerName: "買賣別", headerTooltip: "", width: 94, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MR005", headerName: "市場別", headerTooltip: "", width: 86, cellDataType: "text", },
      { field: "MR004", headerName: "datetime", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "MR003", headerName: "登入代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MR002", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKMR';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMR.*  FROM STKMR`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MR001,MR002,MR003`;
    this.keyFields = ['MR001', 'MR002', 'MR003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MR001', 'MR002', 'MR003'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Stkmr): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmr): Promise<Stkmr> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
